import { Outlet } from "react-router-dom";

function AllTendersLayout() {
  return (
    <>
      {/* Tablolar buraya gelicek */}
      <Outlet />
    </>
  );
}

export default AllTendersLayout;
